import React, { memo, Fragment } from "react";
import { useParams } from "react-router-dom";
import SidebarMenu from "../../../../../components/partials/components/sidebar/sidebar-menu";
import { findIcon } from "../../../../dashboard/icons";

const SponsoredCommunityVerticalNav = memo(() => {
  const { project_id } = useParams();

  return (
    <Fragment>
      <ul className="sub-nav">
        <SidebarMenu
          isTag={"true"}
          staticIcon="false"
          pathname={`/sponsored-community/dashboard/${project_id}`}
          title="Dashboard"
          minititle={findIcon("Dashboard", "dual-tone", 20)}
        >
          <i className="icon">{findIcon("Dashboard", "dual-tone", 20)}</i>
        </SidebarMenu>

        <SidebarMenu
          isTag={"true"}
          staticIcon="false"
          pathname={`/sponsored-community/content/${project_id}`}
          title="Content"
          minititle={findIcon("Document", "dual-tone", 20)}
          sub_active_path="/sponsored-community/content"
        >
          <i className="icon">{findIcon("Document", "dual-tone", 24)}</i>
        </SidebarMenu>

        <SidebarMenu
          isTag={"true"}
          staticIcon="false"
          pathname={`/sponsored-community/analytics/${project_id}`}
          title="Analytics"
          minititle={findIcon("Analytics", "dual-tone", 20)}
        >
          <i className="icon">{findIcon("Analytics", "dual-tone", 20)}</i>
        </SidebarMenu>

        <SidebarMenu
          isTag={"true"}
          staticIcon="false"
          pathname={`/sponsored-community/comments/${project_id}`}
          title="Comments"
          minititle={findIcon("Comment-notification", "dual-tone", 20)}
        >
          <i className="icon">
            {findIcon("Comment-notification", "dual-tone", 20)}
          </i>
        </SidebarMenu>
      </ul>
    </Fragment>
  );
});

export default SponsoredCommunityVerticalNav;
